import { logRBIEvent } from 'features/analytics';
import { CustomEventNames, EventTypes } from 'features/analytics/constants';
import { buildLoyaltyEventAttributes } from 'features/loyalty/utils/analytics';

import { LoyaltyPromotionType, LoyaltyServiceRewardType } from 'generated/graphql-gateway';
import { getIncentiveDayParts } from 'state/loyalty/hooks/utils/incentives-availability';
import { LoyaltyReward } from 'state/loyalty/types';

import { Reward } from '../types';
import { rewardToLoyaltyReward } from '../utils';

export type RewardEvent = {
  name: CustomEventNames.REWARD_SELECTED | CustomEventNames.REWARD_DETAILS_VIEWED;
  incentives: LoyaltyReward[];
  attributes?: Record<string, any>;
};

export function logRewardEvent(
  { name, incentives, attributes }: RewardEvent,
  logOptions?: { flushBrazeAfterLog?: boolean; skipLoggingToBraze?: boolean }
) {
  logRBIEvent(
    {
      name,
      type: EventTypes.Other,
      attributes: buildLoyaltyEventAttributes(incentives, attributes),
    },
    logOptions
  );
}

const getRewardDayParts = (reward: Reward): string[] =>
  (getIncentiveDayParts(rewardToLoyaltyReward(reward)) || []).filter(
    (dayPart): dayPart is string => typeof dayPart === 'string'
  );

export const logRewardSelected = (reward: Reward): void => {
  const cmsId = reward.cmsId || '';

  logRBIEvent({
    name: CustomEventNames.REWARD_SELECTED,
    type: EventTypes.Other,
    attributes: {
      dayParts: getRewardDayParts(reward),
      engineId: reward.id,
      incentiveSanityId: cmsId,
      incentiveType: LoyaltyPromotionType.REWARD,
      loyaltyEngineId: reward.id,
      name: reward.name,
      sanityId: cmsId,
      type: reward.type === LoyaltyServiceRewardType.CONFIG ? 'ConfigReward' : 'Reward',
    },
  });
};
